import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  maskName,
  ListItemBox,
  ListElemDot,
  ListItemCont,
  ListItemBoxRow,
  useTranslation,
  ListItemBoxText,
  ListItemBoxCell,
  ListItemBoxHeader,
  getAmountWithCurrency,
} from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';

const { convertAmount, exchangeAmountByRate } = require('@pascal/pascal-core');

export const CurrentAndTopWinnersItem = observer(({ betData }) => {
  const t = useTranslation();

  return (
    <ListItemCont>
      <ListItemBox>
        <ListItemBoxHeader>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(globalTranslationKeys.PlayerId)} />
          </ListItemBoxCell>
          <ListItemBoxCell size='small'>
            <ListItemBoxText text={maskName(betData.playerExternalId)} size='big' />
          </ListItemBoxCell>
        </ListItemBoxHeader>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(globalTranslationKeys.BetType)} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListElemDot type={betData.additionalParams.market} />
            <ListItemBoxText size='big' text={`x${betData.odd}`} />
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(globalTranslationKeys.Bet)} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              size='big'
              text={`${getAmountWithCurrency({
                amount: convertAmount(exchangeAmountByRate(betData).amount),
                isShowRealCurrency: true,
                withSpace: true,
              })}`}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(globalTranslationKeys.Win)} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              className='win-color'
              size='big'
              text={`${getAmountWithCurrency({
                amount: convertAmount(exchangeAmountByRate(betData).winAmount),
                isShowRealCurrency: true,
                withSpace: true,
              })}`}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
      </ListItemBox>
    </ListItemCont>
  );
});
